<template>
    <div class="main">
        <div class="home apply shadow">
            <div class="innerForm">
                <el-form label-width="80px" :rules="rules4" ref="ruleForm" :model="form" :validate-on-rule-change="false">
                    <div class="redo">
                        <el-row class="rowButton">
                            <span class="applicationText">申请人类别</span>
                            <el-col :span="18" class="colLeft">
                                <el-radio-group v-model="form.applicantType">
                                    <el-radio label="1" :disabled="edit1">公民
                                    </el-radio>
                                    <el-radio label="2" :disabled="edit1">法人/其他组织
                                    </el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="box">
                        <div v-show="isActive === 0">
                            <el-row class="rowButton">
                                <span class="applicationText">公民</span>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="姓名">
                                        <p class="wordWrap">{{ form.name }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="联系电话">
                                        <p class="wordWrap">{{ form.tel }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="证件名称">
                                        <p class="wordWrap">{{ form.certificateType }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="证件号码">
                                        <p class="wordWrap">{{ form.certificateNo }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="电子邮箱">
                                        <p class="wordWrap">{{ form.email }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="邮政编码">
                                        <p class="wordWrap">{{ form.postalcode }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="通信地址">
                                        <p class="wordWrap">{{ form.address }}</p>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                        <div v-show="isActive === 1">
                            <el-row class="rowButton">
                                <span class="applicationText">法人/其他组织</span>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="单位名称">
                                        <p class="wordWrap">{{ form.name }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="法定代表人">
                                        <p class="wordWrap">{{ form.legal }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="组织类型">
                                        <p class="wordWrap">{{ form.organizationType }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="组织机构代码">
                                        <p class="wordWrap">{{ form.certificateNo }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="营业执照信息">
                                        <p class="wordWrap">{{ form.licenseInfo }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="联系人姓名">
                                        <p class="wordWrap">{{ form.contactName }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="电子邮箱">
                                        <p class="wordWrap">{{ form.email }}</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="邮政编码">
                                        <p class="wordWrap">{{ form.postalcode }}</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label-width="150px" label="通信地址">
                                        <p class="wordWrap">{{ form.address }}</p>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                    </div>

                    <div class="redo" style="margin-bottom: 20px">
                        <el-row class="rowButton">
                            <span class="applicationText">所需信息情况</span>
                        </el-row>
                    </div>
                    <div>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="申请时间">
                                    <p class="wordWrap">{{ form.createTime | formatDate}}</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="标题">
                                    <p class="wordWrap">{{ form.title }}</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="申请目的">
                                    <p class="wordWrap">{{ form.applicationPurpose }}</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="所需信息的内容描述">
                                    <p class="wordWrap">{{ form.content }}</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="信息获取方式">
                                    <el-radio-group v-model="form.accessWay" style="text-align: left">
                                        <el-radio label="1" :disabled="edit1">网上查询</el-radio>
                                        <el-radio label="2" :disabled="edit1">邮寄</el-radio>
                                        <el-radio label="3" :disabled="edit1">自行领取</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="redo" style="margin-bottom: 20px">
                        <el-row class="rowButton">
                            <span class="applicationText">补正告知书</span>
                        </el-row>
                    </div>
                    <div style="margin-bottom: 20px">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="补正告知书内容">
                                    <p class="wordWrap">{{form.content}}</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="tableData && tableData.length > 0">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="附件">
                                    <el-row v-for="(item,index) in tableData" :key="index" class="fujianContent">
                                        <el-col :span="20" class="fujianInner"><a :href='urlActionDraw+"?attachmentId="+item.id' class="fujianA">
                                            <i class="el-icon-paperclip"></i>&nbsp&nbsp{{item.fileName}}.{{item.fileExt}}</a>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="redo" style="margin-bottom: 20px">
                        <el-row class="rowButton">
                            <span class="applicationText">补正信息填写</span>
                        </el-row>
                    </div>
                    <div>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="补正信息内容" prop="additionInfo">
                                    <el-input v-model="form.additionInfo" type="textarea"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label-width="150px" label="附件">
                                    <el-upload
                                            :data="fileData"
                                            name="file"
                                            style="text-align: left"
                                            class="upload-demo"
                                            :on-exceed="handleExceed"
                                            :on-remove="handleRemove"
                                            :action="urlAction"
                                            :before-upload="beforeAvatarUpload4"
                                            :file-list="fileList"
                                            :limit="1">
                                        <el-button slot="trigger" size="small" type="primary">请选择上传附件</el-button>
                                        <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
                                            请上传附件
                                        </div>
                                    </el-upload>
                                </el-form-item>

                            </el-col>
                        </el-row>
                    </div>

                    <div class="footer">
                        <el-button type="primary" @click="submit('ruleForm')" style="font-size: 14px">提交</el-button>
                        <el-button type="info" @click="$router.go(-1)" style="margin-left: 50px;font-size: 14px">取消
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    // import Base64 from '@/utils/base64.js'
    import {formatDate} from "@/utils/format"

    export default {
        data() {
            return {
                attachmentId:'',
                tableData: [],
                urlActionDraw: window.SITE_CONFIG['baseUrl'] + '/file/downloadFile',
                urlAction: window.SITE_CONFIG['baseUrl'] + '/file/uploadFile',
                fileList: [],
                fileData: {
                    tableUuid: '',
                    tableName: '',
                    tableKey: '',
                },
                edit1: true,
                id: '',
                form: {
                    replyId: '',
                    id: '',
                    additionInfo: '',
                    correctAttachment: '',
                    certificateNo: '',
                    applicantType: '',
                },
                rules4: {
                    additionInfo: [
                        {required: true, message: '请输入补正信息内容', trigger: 'change'},
                    ],
                },
                paramsStore: {},
                isActive: 0
            }
        },
        filters: {
            formatDate(time) {
                var data = new Date(time);
                return formatDate(data, 'yyyy-MM-dd');
            }
        },
        watch: {
            $route(to, from) {
                this.$router.go(0)
            }
        },
        mounted() {
            this.getIdSelect()
            this.getFileMetaData()
        },
        methods: {
            getIdSelect() {
                const detailId = this.$route.query.id4
                this.$axios({url: '/application/queryById', method: 'get', params: {id: detailId}}).then(({data}) => {
                    const that = this
                    that.form = data.result
                    if (that.form.applicantType == 1) {
                        that.isActive = 0
                    } else {
                        that.isActive = 1
                    }
                })
            },
            getFileMetaData() {
                const fileId = this.$route.query.id3
                this.id = fileId
                var fileData = {
                    tableUuid: this.id,
                    tableName: 'applicationForm',
                    tableKey: 'formalReply',
                }
                this.$axios({url: '/file/getFileMetaData', method: 'post', data: fileData}).then(({data}) => {
                    this.tableData = data.result
                })
            },
            //超出限制
            handleExceed(files, fileList) {
                this.$message.warning(`已超出限制，最多只能上传一个附件！`);
            },
            //删除附件
            handleRemove(response,file, fileList) {
                this.attachmentId = response.response.attachmentId
                this.$axios({
                    url: '/file/deleteFile',
                    method: 'get',
                    params: {attachmentId: this.attachmentId}
                }).then(({data}) => {
                    this.$message.success(data.msg);
                    // console.log(data)
                })
            },
            //上传附件
            beforeAvatarUpload4(file) {
                const isLt2M3 = file.size / 1024 / 1024 < 10;
                if (!isLt2M3) {
                    this.$message.error('上传附件大小不能超过 10MB!');
                }
                this.fileData.tableUuid = this.form.id
                this.fileData.tableName = 'applicationForm'
                this.fileData.tableKey = 'basicInformationBzAttach'
                return isLt2M3;
            },

            route_goFun4(name) {
                this.$router.push({
                    path: '/select-result',
                    query: {
                        name: name,
                        id: 4
                    }
                })
            },
            // 提交内容
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios({
                            url: '/application/correctInfo',
                            method: 'post',
                            data: this.$axios.encrypt(this.form)
                        }).then(({data}) => {
                            if (data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    message: '提交成功!',
                                    type: 'success'
                                });
                                this.$router.push({
                                    path: '/select-result-table',
                                    query: {
                                        name: '申请进度查询',
                                        id: 3,
                                        tel: this.form.tel,
                                        certificateNo: this.form.certificateNo,
                                        pageSize: ' '
                                    }
                                });
                            } else {
                                alert(data.msg)
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },

        }
    }

</script>

<style>
    .apply {
        text-align: center;
        width: 60%;
        margin: 0 auto;
        padding: 20px 10px;
        margin-top: 12px;
    }

    .apply .box {
        margin-top: 20px;
    }

    .apply .line {
        width: 90%;
        margin-left: 10%;
        height: 1px;
        background-color: #95abd461;
        margin-bottom: 14px;
    }

    .apply .footer {
        margin-top: 20px;
        margin-bottom: 40px;
    }

    .apply .redo {
        color: #008cff;
    }

    .apply {

    }

    .apply .box {
        margin-top: 20px;
    }

    .apply .line {
        width: 90%;
        margin-left: 10%;
        height: 1px;
        background-color: #95abd461;
        margin-bottom: 14px;
    }

    .apply .footer {
        margin-top: 20px;
        margin-bottom: 40px;
    }

    .dialogs .el-form-item__label {
        text-align: left;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
    }

    .buttonShow {
        display: none;
    }
</style>
